import React, { useEffect, useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { WHITE_LABEL_MARKET } from '../../lib/white-label';
import { TidalButton } from '../common/button';
import { analytics } from '../../lib/analytics';

export default function PurchaseForm({ intentSecret }) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    if (!intentSecret) {
      return;
    }

    stripe.retrievePaymentIntent(intentSecret).then((res) => {
      const { paymentIntent } = res;

      if (!paymentIntent.last_payment_error) {
        return;
      }

      switch (paymentIntent.status) {
        case 'requires_capture':
          setMessage('Payment saved!');
          break;
        case 'processing':
          setMessage('Your payment is authorizing.');
          break;
        case 'requires_payment_method':
          setMessage(
            paymentIntent.last_payment_error.message ||
              'Your payment was not successful, please try again.',
          );
          break;
        default:
          setMessage('Something went wrong.');
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${process.env.NEXT_PUBLIC_BASE_URL}/reactivate-listings`,
      },
    });

    analytics.track('Seller Added Payment');

    if (error.type === 'card_error' || error.type === 'validation_error') {
      setMessage(error.message);
    } else {
      setMessage('An unexpected error occurred.');
    }

    setIsLoading(false);
  };

  return (
    <form
      id="payment-form"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <PaymentElement
        id="payment-element"
        options={{
          wallets: { applePay: 'auto', googlePay: 'auto' },
          business: { name: WHITE_LABEL_MARKET },
          terms: {
            card: 'always',
          },
          paymentMethodOrder: ['card', 'link', 'apple_pay', 'google_pay'],
          layout: { type: 'tabs' },
        }}
      />
      <div className="flex flex-row items-center p-6 space-x-2 rounded-b dark:border-gray-600">
        {message && (
          <div className="mr-auto" id="payment-message">
            {message}
          </div>
        )}

        <div className="ml-auto">
          <TidalButton
            text="Save Payment"
            onClick={handleSubmit}
            type="info"
            tint={false}
            isLoading={isLoading}
          />
        </div>
      </div>
    </form>
  );
}
